import { FC } from 'react';
import { Address } from 'models/profile-settings.model';
import { ReadOnlyDetailsSection } from '../read-only-details-section.component';

interface AddressInformationProps {
  homeAddress: Address | undefined;
  mailingAddress: Address | undefined;
  onSave?: (home: Address, mailing: Address) => void;
  disableUnsavedModal?: boolean;
}

export const AddressInformationComponent: FC<AddressInformationProps> = () => (
  <ReadOnlyDetailsSection
    title="STR_ADDRESS"
    description="STR_PROFILE_SETTINGS_ADDRESS_DESCRIPTION"
  />
);
